import * as React from 'react';
import Svg, {Circle, Path} from 'react-native-svg';
type NotifyDealIconProps = {
  width: number;
  height: number;
  bgColor?: string;
  opacity?: number;
};
export default class NotifyDealIcon extends React.Component<NotifyDealIconProps> {
  render() {
    return (
      <Svg width={40} height={40} viewBox="0 0 40 40" fill="none">
        <Circle
          cx={20}
          cy={20}
          r={20}
          fill={this.props.bgColor ?? '#003349'}
          fillOpacity={this.props.opacity ?? 0.2}
        />
        <Path
          d="M16.528 16.527h.007m9.43 4.451l-4.979 4.98a1.389 1.389 0 01-1.965 0l-5.965-5.959v-6.944H20l5.965 5.965a1.389 1.389 0 010 1.958z"
          stroke={this.props.bgColor ?? '#003349'}
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </Svg>
    );
  }
}
